// import { Link } from "react-router-dom";
import { OrganizationTerminalStatusLog } from "../../../components/OrganizationTerminalStatusLog";
import MainLayout from "../../../layouts/MainLayout";
import ReactLoading from 'react-loading';
import { styled } from "@mui/system";
//import ButtonMUI from "@mui/material/Button";
import { useSelector } from "react-redux";
import { selectOrganizationId } from "../../../features/cms/organizationBreadcrumbSlice";
import { useGetTerminalStatusLogQuery } from "../../../gateways/cms/logApi";
import { useLazyManualRebootQuery } from "../../../gateways/cms/terminalApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';

// style
const OrganizationTitle = styled("section")`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px;
    // margin-bottom: 16px;

    h2 {
        font-size: 24px;
        margin: 0 40px 0 0;
    }

    // --- スマホ対応 ---
    @media (max-width: 900px) {
        padding: 16px;
        flex-direction: column; // 縦並びに
        align-items: flex-start;
        
        h2 {
            font-size: 20px; // 文字を少し小さく
            margin: 0 0 12px 0; // 下に余白
        }
    }
`;

const ModalContainer = styled("div")`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    z-index: 1000;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    border: 1px solid #ccc;
    
`;

const Loading = styled("section")`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60vh; 
    width: 100%;

    b {
        font-size: 14px;
        color: #A9A9A9;
        font-weight: normal;
        margin-top: 10px;
    }
`;
/** タスク追加 無効のためコメントアウト
const Button = styled(ButtonMUI)`
    height: 32px;
    border-radius: 2px;
`;
** コメントアウトここまで **/

export function TerminalStatusLogPage() {
    const organizationId = useSelector(selectOrganizationId);
    const entries = useGetTerminalStatusLogQuery(organizationId);

    // --- 20260421追加：URLの状態を監視 ---
    const navigate = useNavigate();
    const location = useLocation();
    // モーダル管理用
    const [showRebootModal, setShowRebootModal] = useState(false);
    // const [targetTerminalId, setTargetTerminalId] = useState<string | null>(null);
    const [terminalId, setTerminalId] = useState<string | null>(null);
    // リブートAPI送付をする際のデータを保持
    const [rebootParams, setRebootParams] = useState<{ signature: string, expires: string } | null>(null);
    // 
    const [triggerReboot, { isLoading: isRebooting }] = useLazyManualRebootQuery();
    // 200,403,500のAPIサーバとのやり取り
    const [resultMessage, setResultMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);
    // ★ 再起動実行ボタンの処理
    const handleRebootExecute = async () => {
        console.log(`端末ID: ${terminalId} の再起動APIを実行`);
        if (!terminalId || !rebootParams) return;
        setResultMessage(null);

        try {
            // APIリクエスト実行
            await triggerReboot({
                terminalId: terminalId,
                signature: rebootParams.signature,
                expires: rebootParams.expires,
            }).unwrap();

            setShowRebootModal(false);
            alert("再起動コマンドを正常に送信しました。");

        } catch (error: any) {
            //リダイレクト処理
            if (error.status === 401) {
                const currentUrl = encodeURIComponent(location.pathname + location.search);
                // フロントのログイン成功処理でこの "redirect" を見るようにする
                window.location.href = `/login?redirect=${currentUrl}`;
                return;
            }
            console.error("再起動エラー詳細:", error);

            const status = error.status;
            let message = "予期せぬエラーが発生しました。";

            if (status === 403) {
                // Redisにキーがない、または期限切れ
                message = "このリンクは有効期限が切れているか、無効なURLです。";
            } else if (status === 500) {
                // Redisのステータスが 'processed'
                message = "このリクエストは既に実行済みです。二重送信はできません。";
            } else if (status === 404) {
                message = "対象の端末が見つかりませんでした。";
            }

            alert(message);

        } finally {
            setShowRebootModal(false);
        }
    };

    useEffect(() => {
        // 「?」以降を解析する関数
        // http://127.0.0.1:3001/logs/terminal-status　→これ以降　?expires=1776766316&signature=18d92afbd96d6ecd95d7e21be0a371f862191c7dd19edf4f72ae2a7b52504a08&terminalId=14
        const queryParams = new URLSearchParams(location.search);
        console.log("現在のクエリパラメータ:", queryParams.toString());
        // パラメータを個別に取得
        const signature = queryParams.get('signature');
        const expires = queryParams.get('expires');
        const tid = queryParams.get('terminalId');

        // モーダル表示処理
        if (signature && expires && tid) {
        
            setTerminalId(tid);
            setRebootParams({ signature, expires });
            setShowRebootModal(true);
            // URLリセット
            navigate(location.pathname, { replace: true });
        }
    }, [location.search, navigate]);
    //}, [location.search]);
    //}, [location, navigate]);

    if (entries.isError) {
        return (
            <MainLayout title="端末状態">
                <Loading>
                    <b>端末状態データの取得に失敗しました。時間をおいて再度お試しください。</b>
                </Loading>
            </MainLayout>
        );
    };

    if (!entries.data) {
        return (
            <MainLayout title="端末状態">
                <Loading>
                    <ReactLoading type="bars" color="#ADD8E6" height={'-1%'} width={'7%'} />
                    <b>端末状態データ取得中</b>
                </Loading>
            </MainLayout>
        );
    };

    return (
        <MainLayout title="端末状態">
            {showRebootModal && (
                <div style={{
                    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white', padding: '20px', zIndex: 1000, borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)', border: '1px solid #ccc',
                    // ここを追加・修正
                    width: '90%', 
                    maxWidth: '400px', 
                }}>
                    <h3>再起動の実行確認</h3>
                    <p>端末ID: <strong>{terminalId}</strong> を再起動しますか？</p>
                    <div style={{
                        display: 'flex',
                        gap: '10px',
                        marginTop: '20px',
                        flexDirection: window.innerWidth < 600 ? 'column' : 'row'
                    }}>
                        {/* 通信中はボタンを無効化（連打防止） */}
                        <button 
                            onClick={handleRebootExecute} 
                            disabled={isRebooting}
                            style={{ 
                                flex: 1, padding: '12px',
                                backgroundColor: isRebooting ? '#ccc' : '#f44336', 
                                color: 'white', border: 'none', borderRadius: '4px',
                                cursor: isRebooting ? 'default' : 'pointer'
                            }}
                        >
                            {isRebooting ? "送信中..." : "再起動する"}
                        </button>
                        <button 
                            onClick={() => setShowRebootModal(false)}
                            style={{ border: '1px solid #ccc', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}
                        >
                            キャンセル
                        </button>
                    </div>
                </div>
            )}

            {/* 2. 背景を暗くするオーバーレイ（オプション） */}
            {showRebootModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999 }} onClick={() => setShowRebootModal(false)} />
            )}

            {entries.data?.map((entry) => (
                <div key={entry.organization.id}>
                    <OrganizationTitle>
                        <h2>{entry.organization.name}</h2>
                        {/** タスク追加 無効のためコメントアウト
                        <Button
                            variant="contained"
                            disableElevation
                            href={`/tasks/create?organizationId=${entry.organization.id}`}
                        >
                            タスク追加
                        </Button>
                        ** コメントアウトここまで **/}
                    </OrganizationTitle>
                    <div style={{ width: '100%', overflowX: 'auto', padding: '0 16px' }}>
                        <OrganizationTerminalStatusLog entry={entry} />
                    </div>
                </div>
            ))}
        </MainLayout>
    );
}
